export const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/index.vue'),
    /* no children */
    meta: {
      "layouta": false,
      "hideInMenu": true,
      "noAffix": true
    }
  },
  {
    path: '/:all(.*)',
    name: 'notFound',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "",
      "hideInMenu": true
    }
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/about.vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "关于",
      "icon": "SfTag",
      "permission": [
        "*"
      ],
      "order": 0
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/download.vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "下载中心",
      "icon": "SfTag",
      "permission": [
        "*"
      ],
      "order": 0
    }
  },
  {
    path: '/feature-statistics-analysis',
    name: 'feature-statistics-analysis',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/feature-statistics-analysis.vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "功能使用统计分析",
      "icon": "SfTag",
      "permission": [
        "*"
      ],
      "order": 0
    }
  },
  {
    path: '/menu-manage',
    name: 'menu-manage',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/menu-manage.vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "菜单管理",
      "icon": "SfTag",
      "permission": [
        "*"
      ],
      "order": 0
    }
  },
  {
    path: '/multilevel_menu_example',
    /* internal name: '/multilevel_menu_example' */
    /* no component */
    children: [
      {
        path: 'page1',
        name: '/multilevel_menu_example/page1',
        component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/multilevel_menu_example/page1.vue'),
        /* no children */
        meta: {
          "title": "导航1"
        }
      },
      {
        path: 'page2',
        /* internal name: '/multilevel_menu_example/page2' */
        /* no component */
        children: [
          {
            path: 'page2-1',
            name: '/multilevel_menu_example/page2/page2-1',
            component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/multilevel_menu_example/page2/page2-1.vue'),
            /* no children */
            meta: {
              "title": "导航2-1"
            }
          },
          {
            path: 'page2-2',
            name: '/multilevel_menu_example/page2/page2-2',
            component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/multilevel_menu_example/page2/page2-2.vue'),
            /* no children */
            meta: {
              "title": "导航2-2"
            }
          },
          {
            path: 'page2-3',
            /* internal name: '/multilevel_menu_example/page2/page2-3' */
            /* no component */
            children: [
              {
                path: 'page2-3-1',
                name: '/multilevel_menu_example/page2/page2-3/page2-3-1',
                component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/multilevel_menu_example/page2/page2-3/page2-3-1.vue'),
                /* no children */
                meta: {
                  "title": "导航2-3-1"
                }
              },
              {
                path: 'page2-3-2',
                name: '/multilevel_menu_example/page2/page2-3/page2-3-2',
                component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/multilevel_menu_example/page2/page2-3/page2-3-2.vue'),
                /* no children */
                meta: {
                  "title": "导航2-3-2"
                }
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/permission_example',
    /* internal name: '/permission_example' */
    /* no component */
    children: [
      {
        path: '',
        name: '/permission_example/',
        component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/permission_example/index.vue'),
        /* no children */
        meta: {
          "title": "权限验证",
          "permission": [
            "*"
          ],
          "activeMenu": "/permission_example",
          "order": 10
        }
      },
      {
        path: 'no_permission',
        name: '/permission_example/no_permission',
        component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/permission_example/no_permission.vue'),
        /* no children */
        meta: {
          "title": "无权限路由",
          "permission": [
            "123123"
          ],
          "activeMenu": "/permission_example",
          "hideInMenu": true
        }
      }
    ],
  },
  {
    path: '/reload',
    name: 'reload',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/reload.vue'),
    /* no children */
    meta: {
      "title": "重新加载",
      "layouta": false,
      "hideInMenu": true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/search.vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "全功能搜索",
      "icon": "SfTag",
      "permission": [
        "*"
      ],
      "order": 0
    }
  },
  {
    path: '/sub_apps',
    /* internal name: '/sub_apps' */
    /* no component */
    children: [
      {
        path: '',
        name: 'sub_apps',
        component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/sub_apps/index.vue'),
        /* no children */
        meta: {
          "title": "子应用",
          "permission": [
            "*"
          ],
          "activeMenu": "/",
          "order": 100,
          "icon": "SfHome"
        }
      }
    ],
  },
  {
    path: '/system-statistics-analysis',
    name: 'system-statistics-analysis',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/system-statistics-analysis.vue'),
    /* no children */
    meta: {
      "layout": "default",
      "title": "系统使用分析",
      "icon": "SfTag",
      "permission": [
        "*"
      ],
      "order": 0
    }
  },
  {
    path: '/un-support-user',
    name: 'un-support-user',
    component: () => import('/app/workspace/DEPLOY/eos-qmp-core/eos-qmp-core-eos-qmp-core-web-container/src/pages/un-support-user.vue'),
    /* no children */
    meta: {
      "layouta": false,
      "title": "系统无权限"
    }
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

